import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('HotelPriceService', HotelPriceService);

  HotelPriceService.$inject = ['RestResource', '$translate', '$filter', 'UtilService'];

  function HotelPriceService(RestResource, $translate, $filter, UtilService) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'hotels';

    var service = {
      searchHotelPrices: searchHotelPrices,
      saveHotelPrices: saveHotelPrices,
    };

    return service;

    ////////////////

    function searchHotelPrices(hotel, filterCriteria) {
      var url = apiUrl + '/' + hotel.id + '/hotel_prices';

      if (!filterCriteria) {
        filterCriteria = {};
      }

      filterCriteria.company_id = hotel.company_id;

      return RestResource.request(
        'get',
        url,
        filterCriteria,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveHotelPrices(hotel, params, editMode) {
      var url = apiUrl + '/' + hotel.id + '/hotel_prices';

      params.company_id = hotel.company_id;
      params.option = !editMode ? 'create' : 'update';

      function success(response) {
        var msg = !editMode ? 'PRICES_ADDED' : 'UPDATED_PRICES';
        utils._successMsg($translate(msg));

        return response.data;
      }
      function failure(response) {
        utils.openModalError(response.data.error);

        return false;
      }

      return RestResource.request('post', url, params, success, failure);
    }
  }
})();
